import { foregroundPaletteVariants } from "../../variants/index.js";
import { sizeVariants } from "../../variants/interactions/iconography.variants.js";
import { tv } from "../../variants/tv.js";
const cdnIconVariants = tv({
    extend: foregroundPaletteVariants,
    base: 'material-symbols-icon antialiased select-none',
    variants: {
        size: sizeVariants
    },
    defaultVariants: {
        size: '20'
    }
});
const cdnIconVariantsFields = Object.keys(cdnIconVariants.variants ?? {});
export { cdnIconVariants, cdnIconVariantsFields };
